import { createFileRoute } from '@tanstack/react-router';
import DistributorPage from '../../views/dashboard-distributors/distributor';

export const Route = createFileRoute('/dashboard/distributors_/$uuid')({
  component: DistributorPage,
});
